import type { ContextState, GetterClass } from '../../../models'

export class ContextGetter implements GetterClass {
  static execute(this: void, state: ContextState): ContextState {
    return state
  }
}
